import createIcon from '../../createIcon';

/**
 * @component @name Checklist
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNy41MzQ4NEgxM1Y5LjUzNDg0SDIyVjcuNTM0ODRaTTIyIDE1LjUzNDhIMTNWMTcuNTM0OEgyMlYxNS41MzQ4Wk01LjU0IDExLjUzNDhMMiA3Ljk5NDg0TDMuNDEgNi41ODQ4NEw1LjUzIDguNzA0ODRMOS43NyA0LjQ2NDg0TDExLjE4IDUuODc0ODRMNS41NCAxMS41MzQ4Wk01LjU0IDE5LjUzNDhMMiAxNS45OTQ4TDMuNDEgMTQuNTg0OEw1LjUzIDE2LjcwNDhMOS43NyAxMi40NjQ4TDExLjE4IDEzLjg3NDhMNS41NCAxOS41MzQ4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Checklist = createIcon('Checklist', [
  [
    'path',
    {
      d: 'M22 7.53484H13V9.53484H22V7.53484ZM22 15.5348H13V17.5348H22V15.5348ZM5.54 11.5348L2 7.99484L3.41 6.58484L5.53 8.70484L9.77 4.46484L11.18 5.87484L5.54 11.5348ZM5.54 19.5348L2 15.9948L3.41 14.5848L5.53 16.7048L9.77 12.4648L11.18 13.8748L5.54 19.5348Z',
      key: '13n765',
    },
  ],
]);

export default Checklist;
